import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'locodeToCountryName'
})
export class LocodeToCountryNamePipe implements PipeTransform {
  private countries = [
    // { name: 'Global', locode: 'global' },
    { name: 'Afghanistan', locode: 'AF' },
    { name: 'Albania', locode: 'AL' },
    { name: 'Algeria', locode: 'DZ' },
    { name: 'Andorra', locode: 'AD' },
    { name: 'Angola', locode: 'AO' },
    { name: 'Antigua and Barbuda', locode: 'AG' },
    { name: 'Argentina', locode: 'AR' },
    { name: 'Armenia', locode: 'AM' },
    { name: 'Australia', locode: 'AU' },
    { name: 'Austria', locode: 'AT' },
    { name: 'Azerbaijan', locode: 'AZ' },
    { name: 'Bahamas', locode: 'BS' },
    { name: 'Bahrain', locode: 'BH' },
    { name: 'Bangladesh', locode: 'BD' },
    { name: 'Barbados', locode: 'BB' },
    { name: 'Belarus', locode: 'BY' },
    { name: 'Belgium', locode: 'BE' },
    { name: 'Belize', locode: 'BZ' },
    { name: 'Benin', locode: 'BJ' },
    { name: 'Bhutan', locode: 'BT' },
    { name: 'Bolivia', locode: 'BO' },
    { name: 'Bosnia and Herzegovina', locode: 'BA' },
    { name: 'Botswana', locode: 'BW' },
    { name: 'Brazil', locode: 'BR' },
    { name: 'Brunei', locode: 'BN' },
    { name: 'Bulgaria', locode: 'BG' },
    { name: 'Burkina Faso', locode: 'BF' },
    { name: 'Burundi', locode: 'BI' },
    { name: 'Cabo Verde', locode: 'CV' },
    { name: 'Cambodia', locode: 'KH' },
    { name: 'Cameroon', locode: 'CM' },
    { name: 'Canada', locode: 'CA' },
    { name: 'Central African Republic', locode: 'CF' },
    { name: 'Chad', locode: 'TD' },
    { name: 'Chile', locode: 'CL' },
    { name: 'China', locode: 'CN' },
    { name: 'Colombia', locode: 'CO' },
    { name: 'Comoros', locode: 'KM' },
    { name: 'Congo (Congo-Brazzaville)', locode: 'CG' },
    { name: 'Costa Rica', locode: 'CR' },
    { name: 'Croatia', locode: 'HR' },
    { name: 'Cuba', locode: 'CU' },
    { name: 'Cyprus', locode: 'CY' },
    { name: 'Czech Republic', locode: 'CZ' },
    { name: 'Democratic Republic of the Congo', locode: 'CD' },
    { name: 'Denmark', locode: 'DK' },
    { name: 'Djibouti', locode: 'DJ' },
    { name: 'Dominica', locode: 'DM' },
    { name: 'Dominican Republic', locode: 'DO' },
    { name: 'Ecuador', locode: 'EC' },
    { name: 'Egypt', locode: 'EG' },
    { name: 'El Salvador', locode: 'SV' },
    { name: 'Equatorial Guinea', locode: 'GQ' },
    { name: 'Eritrea', locode: 'ER' },
    { name: 'Estonia', locode: 'EE' },
    { name: 'Eswatini', locode: 'SZ' },
    { name: 'Ethiopia', locode: 'ET' },
    { name: 'Fiji', locode: 'FJ' },
    { name: 'Finland', locode: 'FI' },
    { name: 'France', locode: 'FR' },
    { name: 'Gabon', locode: 'GA' },
    { name: 'Gambia', locode: 'GM' },
    { name: 'Georgia', locode: 'GE' },
    { name: 'Germany', locode: 'DE' },
    { name: 'Ghana', locode: 'GH' },
    { name: 'Greece', locode: 'GR' },
    { name: 'Grenada', locode: 'GD' },
    { name: 'Guatemala', locode: 'GT' },
    { name: 'Guinea', locode: 'GN' },
    { name: 'Guinea-Bissau', locode: 'GW' },
    { name: 'Guyana', locode: 'GY' },
    { name: 'Haiti', locode: 'HT' },
    { name: 'Honduras', locode: 'HN' },
    { name: 'Hungary', locode: 'HU' },
    { name: 'Iceland', locode: 'IS' },
    { name: 'India', locode: 'IN' },
    { name: 'Indonesia', locode: 'ID' },
    { name: 'Iran', locode: 'IR' },
    { name: 'Iraq', locode: 'IQ' },
    { name: 'Ireland', locode: 'IE' },
    { name: 'Israel', locode: 'IL' },
    { name: 'Italy', locode: 'IT' },
    { name: 'Jamaica', locode: 'JM' },
    { name: 'Japan', locode: 'JP' },
    { name: 'Jordan', locode: 'JO' },
    { name: 'Kazakhstan', locode: 'KZ' },
    { name: 'Kenya', locode: 'KE' },
    { name: 'Kiribati', locode: 'KI' },
    { name: 'Kuwait', locode: 'KW' },
    { name: 'Kyrgyzstan', locode: 'KG' },
    { name: 'Laos', locode: 'LA' },
    { name: 'Latvia', locode: 'LV' },
    { name: 'Lebanon', locode: 'LB' },
    { name: 'Lesotho', locode: 'LS' },
    { name: 'Liberia', locode: 'LR' },
    { name: 'Libya', locode: 'LY' },
    { name: 'Liechtenstein', locode: 'LI' },
    { name: 'Lithuania', locode: 'LT' },
    { name: 'Luxembourg', locode: 'LU' },
    { name: 'Madagascar', locode: 'MG' },
    { name: 'Malawi', locode: 'MW' },
    { name: 'Malaysia', locode: 'MY' },
    { name: 'Maldives', locode: 'MV' },
    { name: 'Mali', locode: 'ML' },
    { name: 'Malta', locode: 'MT' },
    { name: 'Marshall Islands', locode: 'MH' },
    { name: 'Mauritania', locode: 'MR' },
    { name: 'Mauritius', locode: 'MU' },
    { name: 'Mexico', locode: 'MX' },
    { name: 'Micronesia', locode: 'FM' },
    { name: 'Moldova', locode: 'MD' },
    { name: 'Monaco', locode: 'MC' },
    { name: 'Mongolia', locode: 'MN' },
    { name: 'Montenegro', locode: 'ME' },
    { name: 'Morocco', locode: 'MA' },
    { name: 'Mozambique', locode: 'MZ' },
    { name: 'Myanmar (Burma)', locode: 'MM' },
    { name: 'Namibia', locode: 'NA' },
    { name: 'Nauru', locode: 'NR' },
    { name: 'Nepal', locode: 'NP' },
    { name: 'Netherlands', locode: 'NL' },
    { name: 'New Zealand', locode: 'NZ' },
    { name: 'Nicaragua', locode: 'NI' },
    { name: 'Niger', locode: 'NE' },
    { name: 'Nigeria', locode: 'NG' },
    { name: 'North Korea', locode: 'KP' },
    { name: 'North Macedonia', locode: 'MK' },
    { name: 'Norway', locode: 'NO' },
    { name: 'Oman', locode: 'OM' },
    { name: 'Pakistan', locode: 'PK' },
    { name: 'Palau', locode: 'PW' },
    { name: 'Panama', locode: 'PA' },
    { name: 'Papua New Guinea', locode: 'PG' },
    { name: 'Paraguay', locode: 'PY' },
    { name: 'Peru', locode: 'PE' },
    { name: 'Philippines', locode: 'PH' },
    { name: 'Poland', locode: 'PL' },
    { name: 'Portugal', locode: 'PT' },
    { name: 'Qatar', locode: 'QA' },
    { name: 'Romania', locode: 'RO' },
    { name: 'Russia', locode: 'RU' },
    { name: 'Rwanda', locode: 'RW' },
    { name: 'Saint Kitts and Nevis', locode: 'KN' },
    { name: 'Saint Lucia', locode: 'LC' },
    { name: 'Saint Vincent and the Grenadines', locode: 'VC' },
    { name: 'Samoa', locode: 'WS' },
    { name: 'San Marino', locode: 'SM' },
    { name: 'Sao Tome and Principe', locode: 'ST' },
    { name: 'Saudi Arabia', locode: 'SA' },
    { name: 'Senegal', locode: 'SN' },
    { name: 'Serbia', locode: 'RS' },
    { name: 'Seychelles', locode: 'SC' },
    { name: 'Sierra Leone', locode: 'SL' },
    { name: 'Singapore', locode: 'SG' },
    { name: 'Slovakia', locode: 'SK' },
    { name: 'Slovenia', locode: 'SI' },
    { name: 'Solomon Islands', locode: 'SB' },
    { name: 'Somalia', locode: 'SO' },
    { name: 'South Africa', locode: 'ZA' },
    { name: 'South Korea', locode: 'KR' },
    { name: 'South Sudan', locode: 'SS' },
    { name: 'Spain', locode: 'ES' },
    { name: 'Sri Lanka', locode: 'LK' },
    { name: 'Sudan', locode: 'SD' },
    { name: 'Suriname', locode: 'SR' },
    { name: 'Sweden', locode: 'SE' },
    { name: 'Switzerland', locode: 'CH' },
    { name: 'Syria', locode: 'SY' },
    { name: 'Taiwan', locode: 'TW' },
    { name: 'Tajikistan', locode: 'TJ' },
    { name: 'Tanzania', locode: 'TZ' },
    { name: 'Thailand', locode: 'TH' },
    { name: 'Timor-Leste', locode: 'TL' },
    { name: 'Togo', locode: 'TG' },
    { name: 'Tonga', locode: 'TO' },
    { name: 'Trinidad and Tobago', locode: 'TT' },
    { name: 'Tunisia', locode: 'TN' },
    { name: 'Turkey', locode: 'TR' },
    { name: 'Turkmenistan', locode: 'TM' },
    { name: 'Tuvalu', locode: 'TV' },
    { name: 'Uganda', locode: 'UG' },
    { name: 'Ukraine', locode: 'UA' },
    { name: 'United Arab Emirates', locode: 'AE' },
    { name: 'United Kingdom', locode: 'GB' },
    { name: 'United States', locode: 'US' },
    { name: 'Uruguay', locode: 'UY' },
    { name: 'Uzbekistan', locode: 'UZ' },
    { name: 'Vanuatu', locode: 'VU' },
    { name: 'Vatican City', locode: 'VA' },
    { name: 'Venezuela', locode: 'VE' },
    { name: 'Vietnam', locode: 'VN' },
    { name: 'Yemen', locode: 'YE' },
    { name: 'Zambia', locode: 'ZM' },
    { name: 'Zimbabwe', locode: 'ZW' }
  ];
  transform(locode: any): string {
    const searchCode = locode ? locode.toString().toLowerCase() : '';
    const country = this.countries.find(c => {
      const code = c.locode ? c.locode.toString().toLowerCase() : '';
      return code === searchCode;
    });
    return country ? country.name : locode;
  }
}
